import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import Colors from '../styles/colors';

import Fileuploader from './Fileuploader';
import Linkuploader from './Linkuploader';

class Smartuploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showUploadOption: true,
      showImportOption: true,
    };

    this.showComponent = this.showComponent.bind(this);
    this.uploaderRef = {
      file: null,
      link: null,
    };
  }

  componentDidMount() {
    const { autobrowsefile = false } = this.props.fileuploader;
    if (autobrowsefile) {
      setTimeout(() => {
        this.getUploaderRef('file').manualBrowse();
      }, 200);
    }
  }

  getUploaderRef(key) {
    return this.uploaderRef[key];
  }

  showComponent(statekey, statevalue) {
    return () => {
      this.setState({
        [statekey]: statevalue,
      });
    };
  }

  renderOptionalImportLink() {
    if (!this.state.showImportOption) {
      return null;
    }

    let { linkuploader = {} } = this.props;
    if (isEmpty(linkuploader)) {
      return null;
    }

    const {
      onimportstart = () => {},
      onimportcancel = () => {},
      onimportremove = () => {},
    } = linkuploader;

    // modify linkuploader object
    linkuploader = {
      ...linkuploader,
      onimportstart: () => {
        this.showComponent('showUploadOption', false)();
        onimportstart();
      },
      onimportcancel: () => {
        this.showComponent('showUploadOption', true)();
        onimportcancel();
      },
      onimportremove: () => {
        this.showComponent('showUploadOption', true)();
        onimportremove();
      }
    };

    return (
      <div style={styles.optionalImportWrapper}>
        {this.state.showUploadOption && <div style={styles.importOrOption}>OR</div>}
        <Linkuploader {...linkuploader} ref={ref => this.uploaderRef.link = ref} />
      </div>
    );
  }

  renderFilepondUploader() {
    if (!this.state.showUploadOption) {
      return null;
    }

    let { fileuploader, fileuploaderStatusContent } = this.props;
    const {
      onaddfilestart = () => {},
      onremovefile = () => {},
      onerror = () => {}
    } = fileuploader;

    // modify fileuploader object
    fileuploader = {
      ...fileuploader,
      onaddfilestart: (...args) => {
        this.showComponent('showImportOption', false)();
        onaddfilestart(...args);
      },
      onremovefile: (...args) => {
        this.showComponent('showImportOption', true)();
        onremovefile(...args);
      },
      onerror: (...args) => {
        this.showComponent('showImportOption', true)();
        onerror(...args);
      }
    };

    return (
      <React.Fragment>
        <Fileuploader {...fileuploader} ref={ref => this.uploaderRef.file = ref} />
        {fileuploaderStatusContent()}
      </React.Fragment>
    );
  }

  render() {
    return (
      <div id="upload-area" style={{ ...styles.plainWhiteWrapper, ...this.props.style }}>
        {(!isEmpty(this.props.header)) && <div style={styles.miniHeaderText}>
          {this.props.header}
        </div>}
        {this.renderFilepondUploader()}
        {this.renderOptionalImportLink()}
      </div>
    );
  }
}

const styles = {
  plainWhiteWrapper: {
    backgroundColor: Colors.mainWhite,
    padding: '10px 20px',
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10,
  },
  miniHeaderText: {
    fontSize: 18,
    color: Colors.black,
    fontWeight: 800,
    paddingTop: 10,
    paddingBottom: 10,
  },
  optionalImportWrapper: {
    margin: '0 auto',
    width: '100%',
    textAlign: 'center',
    paddingBottom: 10,
  },
  importOrOption: {
    padding: '0px 10px 10px',
  },
};

Smartuploader.propTypes = {
  style: PropTypes.object,
  header: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
  ]),
  fileuploaderStatusContent: PropTypes.func,
  fileuploader: PropTypes.object,
  linkuploader: PropTypes.object,
};

Smartuploader.defaultProps = {
  style: {},
  header: null,
  fileuploaderStatusContent: () => {},
  fileuploader: {},
  linkuploader: {}
};

export default Smartuploader;
